import { useCallback, useEffect, useState } from "react";

export function useTheme() {
  type Theme = "dark" | "light";

  const [theme, setTheme] = useState<Theme>(() => {
    return document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
  });

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    document.cookie = `theme=${theme}; path=/; SameSite=lax; Secure`;
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((theme) => (theme === "dark" ? "light" : "dark"));
  }, []);

  return {
    theme,
    toggleTheme,
  };
}
